import React from 'react'
import { ImageContainer} from 'components'
import PropTypes from 'prop-types'

const Default = (props) => {
    return <ImageContainer frame={props.frame} id={props.id} isInteractive={true} />
}

Default.propTypes = {
    id: PropTypes.string.isRequired,
}

export default Default
